import { defineComponent as _defineComponent } from 'vue'
import { reactive, computed, onMounted, ref } from "vue";
  import ToggleButton from "@/components/ui/ToggleButton.vue";
  import useVuelidate from "@vuelidate/core";
  import { helpers, required } from "@vuelidate/validators";
  import store from "@/store";
  import router from "@/router";
  import { CreateEstate } from "@/types/CreateEstate";
  import {
    isValidFileSize,
    isValidImageType,
    validImagesTypes,
  } from "@/helpers/fileUpload";
  import { latinCharactersRegex } from "@/helpers/regex";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminEstateUpdate',
  setup(__props, { expose: __expose }) {
  __expose();

  const userId = router.currentRoute.value.params.userId;
  const estateId = router.currentRoute.value.params.estateId;
  const estate = ref(null);
  const form = reactive<Partial<CreateEstate>>({
    title: "",
    address: "",
    isRefundable: true,
    iconColor: "#ffffff",
  });
  const file = ref<File | null>(null);
  const latinCharacters = helpers.regex(latinCharactersRegex);
  const rules = computed(() => {
    return {
      title: {
        required,
        latinCharacters: helpers.withMessage("Invalid value", latinCharacters),
        $autoDirty: true,
      },
      address: { required, $autoDirty: true },
    };
  });
  const v$ = useVuelidate(rules, form);
  const logoTypes = validImagesTypes.join(", ");

  onMounted(() => {
    store.dispatch("estate/getEstate", estateId).then((res) => {
      estate.value = res.data;
      form.title = res.data.title;
      form.address = res.data.address;
      form.isRefundable = res.data.isRefundable;
      form.iconColor = res.data.iconColor;
    });
  });

  function selectFile(e: any) {
    if (!e.target.files.length) {
      return;
    }

    const selectedFile = e.target.files[0];

    if (!isValidImageType(selectedFile) || !isValidFileSize(selectedFile)) {
      return;
    }

    file.value = selectedFile;
  }
  const uploadFile = () => {
    const data = new FormData();

    data.append("file", file.value as File);
    return store.dispatch("estate/uploadEstateLogo", { estateId, file: data });
  };

  async function updateEstate() {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) return;

    if (file.value) {
      await uploadFile();
    }

    store
      .dispatch("estate/updateEstate", { id: estateId, data: form })
      .then(() => {
        router.push({
          name: "AdminEstate",
          params: { userId, estateId },
        });
      });
  }

const __returned__ = { userId, estateId, estate, form, file, latinCharacters, rules, v$, logoTypes, selectFile, uploadFile, updateEstate, reactive, computed, onMounted, ref, ToggleButton, get useVuelidate() { return useVuelidate }, get helpers() { return helpers }, get required() { return required }, get store() { return store }, get router() { return router }, get CreateEstate() { return CreateEstate }, get isValidFileSize() { return isValidFileSize }, get isValidImageType() { return isValidImageType }, get validImagesTypes() { return validImagesTypes }, get latinCharactersRegex() { return latinCharactersRegex } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})